import './navbar.scss';
import './../styles/index.scss';
import { useEffect, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { RETURNS_UI_URLS } from '../constants';
// import LogoutIcon from '@mui/icons-material/Logout';

export default function Navbar(data1) {
  let data = data1.data;
  const [note, setNote] = useState({});
  
  useEffect(() => {
    getNoteText();
  },[])

    const getNoteText = async () => {   
        try{     
            const response = await fetch(RETURNS_UI_URLS.BASE_URL+'return-portal-config', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Fenix-Tenant-Id': (JSON.parse(sessionStorage.getItem('retailerData')).tenantId)
                }
            });
            if (response?.status === 200) {
                const result = await response.json();
                    if (result) {
                        sessionStorage.setItem('config-data', JSON.stringify(result));
                        setNote(result?.header_banner);
                    }
                    else {
                        setNote(null);
                    }
            }
            else {
                setNote(null);
            }
        }
    catch (error) {
        setNote(null);
    }

    }

    const clearNote = () => {        
        setNote(note.display = false);
    }

    return (
        <div className={`nav-wrapper ${data?.type}wrap`}>
           {note?.display ?
            <div className={` display-flex ${data?.type}note-wrapper text-center f-16 p-10 fw-500 `} >
             <div className="width-98per" >
            <div className='' dangerouslySetInnerHTML={{ __html: note?.content }} ></div>
            </div>
             <div className="align-center">
             <ClearIcon className='f-20 white-color cursor-pointer' onClick={() => clearNote()} />
            </div> 
            </div>
             :''}
            <div className="row d-none">
                <div className="w">
                <div className="col-md-12 text-center p-10">
                            <img className='cursor-pointer logo-size' src={require(`../assets/images/${data?.fileUrl}`)} onClick={() => window.open(data?.store_url)} alt={data?.type} />
                            {/* {<span className='float-right mt-10'><LogoutIcon sx={{ fontSize: 24, color:'#1b375d' }}/>&nbsp;&nbsp;<a href='login' onClick={e => window.history.go(-1)} className="primary-color fw-500">Logout</a></span>} */}
                    </div>
                </div>
            </div>
            <nav className="navbar flex-nowrap flex-xl-wrap justify-content-xl-center navbar-expand-xl">
                <div className={`container justify-content-xl-center ${data?.type}Container-nav`}>
                    <div className={`navbar-logo w-100 text-left text-xl-center ${data?.type}Navbar-logo`}>
                        <img src={require(`../assets/images/${data.fileUrl}`)} className={`nav-logo cursor-pointer ${data.type}`} onClick={() => window.open(data?.store_url)} alt={data.type} />
                    </div>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse justify-content-center navbar-default mob-nav ${data.type}`} id="navbarNav">
                        <ul className='navbar-nav'>
                            {data.menuName?.map((menu,key) => {
                            return <li className="nav-item"  key={key}>
                                <a className={`header-menu nav-link ${data.type === 'janieandjack' || data.type === 'hatchcollections' || data.type === 'travelpro' || data.type === 'wearhumans' ? data.type :'white-color'} cursor-pointer`} href={menu.hrefLink}
                                    target="_blank" rel="noopener noreferrer">{menu.menu}</a>
                            </li>
                            })}
                            {/* <li className='float-right'>
                            {<span className='float-right mt-10'><LogoutIcon sx={{ fontSize: 24, color:'#1b375d' }}/>&nbsp;&nbsp;<a href='login' onClick={e => window.history.go(-1)} className="primary-color fw-500">Logout</a></span>}
                            </li> */}
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    )
}
